import CarBreadcrumb from "../../commonComponents/breadcrumbs/CarBreadcrumb";
import CarDetail from "../../commonComponents/productDetail/CarDetail";

const CarSliderContainer = () => {
  return (
    <>
      <CarBreadcrumb type="car_image_slider" />
      <CarDetail type="car" />
    </>
  );
};

export default CarSliderContainer;
